import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Pivot, PivotItem } from 'office-ui-fabric-react';
import PageTitle from '../../components/PageTitle';
import Main from '../../components/Main';
import styles from './ProductListing.style';
import ProductListTab from '../../components/ProductListTab';
import BundleListTab from '../../components/BundleListTab';
import { can } from '../../utils/auth';

const ProductListing = () => {
  const { state: locationState, pathname } = useLocation();
  const history = useHistory();
  const [selectedKey, setSelectedKey] = useState('products');

  useEffect(() => {
    if (locationState?.tabName === 'bundles') {
      setSelectedKey('bundles');
    } else {
      setSelectedKey('products');
    }
  }, [locationState]);

  return (
    <>
      <PageTitle>Products</PageTitle>
      <Main>
        <Pivot
          selectedKey={selectedKey}
          onLinkClick={item => {
            history.push({
              pathname,
              state: { tabName: item.props.itemKey },
            });
          }}
        >
          <PivotItem headerText="Products" itemKey="products" className={styles.item}>
            <ProductListTab />
          </PivotItem>
          {can('viewBundles') && (
            <PivotItem headerText="Bundles" itemKey="bundles" className={styles.item}>
              <BundleListTab />
            </PivotItem>
          )}
        </Pivot>
      </Main>
    </>
  );
};

export default ProductListing;
